<template>
<div>
  <Main />
  <div class="text-center mt-5 mb-3">
    <b-button variant="success" v-on:click="toggleAdvancedSearch()">Single instrument search</b-button>
  </div>
  <div v-if="searchForm.advancedSearch">
    <b-tabs content-class="mt-3" v-on:input="tabChanged()" v-model="searchForm.secondaryTab">
      <b-tab title="LUCI">
        <Lucifer />
      </b-tab>
      <b-tab title="MODS">
        <Mods />
      </b-tab>
      <b-tab title="LBC">
        <Lbc />
      </b-tab>
      <b-tab title="IRTC">
        <Irtc />
      </b-tab>
      <b-tab title="PISCES">
        <Pisces />
      </b-tab>
      <b-tab title="LBTI">
        <Lbti />
      </b-tab>
    </b-tabs>
  </div>
</div>
</template>

<script>
import Main from './Main.vue';
import Lbc from './Lbc.vue';
import Lucifer from './Lucifer.vue';
import Irtc from './Irtc.vue';
import Mods from './Mods.vue';
import Pisces from './Pisces.vue';
import Lbti from './Lbti.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'Form',
  components: {
    Main,
    Lbc,
    Lucifer,
    Irtc,
    Mods,
    Pisces,
    Lbti
  },
  computed: mapState({
    searchForm: state => state.searchForm
  }),
  methods: {
    toggleAdvancedSearch() {
      this.$store.commit('toggleAdvancedSearch');
    },
    tabChanged() {
      this.$store.commit('tabChanged');
    }
  }
}
</script>

<style>
body {
  background: url('background.jpg');
}

.radio-toolbar input[type="radio"] {
  display: none;
}

.radio-toolbar label {
  display: inline-block;
  background-color: #f1f1f1;
  padding: 2px 6px;
  font-family: sans-serif, Arial;
  font-weight: normal !important;
  border: 1px solid #999;
}

.radio-toolbar label:first-of-type {
  border-radius: .25rem 0 0 .25rem;
  padding-left: 8px;
}

.radio-toolbar label:last-of-type {
  border-radius: 0 .25rem .25rem 0;
  padding-right: 8px;
}

.radio-toolbar input[type="radio"]:checked+label {
  background-color: #8ac3ff;
  border-color: #007bff;
}

.radio-toolbar label:hover {
  background-color: #cfe7ff;
  cursor: pointer;
}
</style>
